import { useSelector } from 'react-redux';

const useProfilePicture = () => {
  const profilePic = useSelector((state) => state.me.meReducer.data?.picture);
  return profilePic;
};

export default useProfilePicture;
